import i18next, { Resource, i18n } from 'i18next';
import resourcesToBackend from "i18next-resources-to-backend"
import { Language } from '@moodys/cre-cpm-client-apis.apis.services.auth';
import { DefaultLanguage } from '@moodys/cre-cpm.constants.localization';

// Needed because the with-translation component (remove after upgrade all microfrontends to >0.14)
i18next.init()

export const convertLocaleToIso = (locale: Language): string => (locale === 'de' ? 'de-DE' : 'en-US');

export const createI18nInstance = (namespaces: string[], resources: Resource = {}): i18n => {
  const i18nInstance = i18next
    .createInstance({
      interpolation: { escapeValue: false },
      lng: DefaultLanguage,
      fallbackLng: DefaultLanguage,
      ns: namespaces,
      defaultNS: namespaces[0],
      debug: false
    })
    .use(
      resourcesToBackend(
        (language: string, namespace: string) =>
          resources && resources[language] && resources[language][namespace]
      )
    )
  i18nInstance.init()
  return i18nInstance
}
